import React from 'react'
import styled, { keyframes } from 'styled-components';
import { connect } from 'react-redux'
import Modal from './ui/modal'

const Loader = props =>
  props.loader ? (
    <Modal>
      <Container>
        <Spinner />
      </Container>
    </Modal>
  ) : null

const mapStateToProps = ({ loader }) => {
  return { loader }
}
export default connect(mapStateToProps)(Loader)


const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
`;

export const Spinner = styled.div`
  width: 79.49px;
  height: 79.49px;
  border: 4px solid rgba(0, 122, 255, 0.1);
  border-top-color: ${props => props.theme.colors.brand.lightBlue || '#007AFF'};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;